export default __webpack_public_path__ + "static/media/Proxima Nova Thin.e700c29b.otf";